/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { useArg } from 'solis/navigation';

import Hex from 'solis/type/hex';


// Clicking a hex stores its absolute hex under the pane's zone arg key. Resolve it back
// to a zone (or null) against the rendered data — a colony or a board, both expose getZone.
export default (data, key) =>
{
  const zone = useArg(key);

  return zone ? data.getZone(new Hex(zone)) : null;
};
